import { Observable, iif, mergeMap, of, throwError } from 'rxjs';
import { Injectable } from '@angular/core';

import { LoginResult } from '../entities/login-result.entity';
import { WebApiService } from './web-api.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private readonly LOGIN_PATH = "/api/v1.1/authentication/login";

  constructor(private webApiService: WebApiService) {}

  /**
   * POST /authentication/token
   * Retrieves an token authentication token from a username and a password.
   * Check if username is an activation code or not to use email or activationCode
   * @param username
   * @param password
   * @returns authentication result if user role is enabled, otherwise an error
   */
  public authenticate(
    username: string,
    password: string
  ): Observable<LoginResult> {
    let data: any;
    if (username.length === 8 && username.indexOf("@") === -1) {
      data = {
        activationCode: username,
        password: password,
      };
    } else {
      data = {
        email: username,
        password: password,
      };
    }
    return this.webApiService.post(this.LOGIN_PATH, data).pipe(
        mergeMap((response: { data: any }) => {
          const loginResult = new LoginResult().deserialize(response.data);

          return iif(() => loginResult.canAccessByRole(), of(loginResult), throwError(() => new Error("Access denied")));
        })
    );
  }
}
